import React from 'react'

export default function DashboardLoader() {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "100%", width: "100%" }}>
            <div className="spinner-border text-primary" role="status"></div>
            <span className="visually-hidden">Loading...</span>
        </div>
    )
}
